import { Link } from 'react-router-dom';

// Locally-hosted, WebP-optimised logo (served from /public).
const LOGO_SM = '/logo-sm.webp'; // ~11KB, 256px
const LOGO_MD = '/logo-md.webp'; // ~21KB, 480px

/**
 * Brand logo displayed as a small light "decal" badge so the
 * white-background emblem sits cleanly on the dark UI.
 */
export default function BrandLogo({
  size = 'sm', // sm = navbar, md = footer, lg = pages
  asLink = true,
  className = '',
  testId = 'brand-logo',
  priority = false,
}) {
  const dimensions =
    size === 'lg'
      ? 'w-28 h-28 sm:w-32 sm:h-32'
      : size === 'md'
      ? 'w-20 h-20 sm:w-24 sm:h-24'
      : 'w-16 h-16 sm:w-20 sm:h-20';

  const src = size === 'sm' ? LOGO_SM : LOGO_MD;

  const inner = (
    <span className={`inline-flex items-center group ${className}`}>
      <span
        className={`${dimensions} shrink-0 rounded-full bg-[#F5F5F0] flex items-center justify-center overflow-hidden ring-1 ring-white/15 shadow-[0_10px_28px_-12px_rgba(155,17,30,0.5)] transition-transform duration-300 group-hover:scale-[1.04]`}
      >
        <img
          src={src}
          alt="The Meat Works — established 2001, finest quality meats"
          width={size === 'sm' ? 64 : 96}
          height={size === 'sm' ? 64 : 96}
          loading={priority ? 'eager' : 'lazy'}
          fetchPriority={priority ? 'high' : 'auto'}
          decoding="async"
          className="w-[112%] h-[112%] object-contain"
        />
      </span>
    </span>
  );

  if (!asLink) {
    return (
      <span data-testid={testId} className="inline-flex items-center">
        {inner}
      </span>
    );
  }

  return (
    <Link to="/" data-testid={testId} aria-label="The Meat Works · Home" className="inline-flex items-center">
      {inner}
    </Link>
  );
}
